import { TranslationFile } from 'i18n'
import { IApplicationInformation } from 'interfaces/i-application-information'
import { useTranslation } from 'react-i18next'

export const ApplicationExpensesForm = (data: IApplicationInformation) => {
	const { t } = useTranslation([TranslationFile.Forms])

	return {
		fieldSetName: '',
		formName: 'ApplicationExpensesForm',
		description: t('forms:ExpensesDescription'),
		collapsable: false,
		show: true,
		visible: true,
		market: 'es',
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'otherLoansOrCreditCards',
				type: 'radio',
				description: t('forms:OtherLoansOrCreditCardsDescription'),
				options: [
					{
						value: true,
						label: t('forms:Yes'),
					},
					{
						value: false,
						label: t('forms:No'),
					},
				],
				visible: true,
				col: 12,
			},
			{
				required: true,
				controlName: 'otherTotal',
				type: 'number',
				label: t('forms:LoansOtherTotal'),
				visible: false,
				condition: [
					{
						when: 'all',
						action: 'show',
						items: [
							{
								field: 'otherLoansOrCreditCards',
								rule: 'equal',
								value: true,
							},
						],
					},
				],
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^[0-9]*$',
						message: t('forms:ValidationMsgValue'),
					},
				],
				col: 12,
			},
			{
				required: true,
				controlName: 'otherMonthlyCost',
				type: 'number',
				label: t('forms:LoansOtherMonthlyCost'),
				visible: false,
				condition: [
					{
						when: 'all',
						action: 'show',
						items: [
							{
								field: 'otherLoansOrCreditCards',
								rule: 'equal',
								value: true,
							},
						],
					},
				],
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^[0-9]*$',
						message: t('forms:ValidationMsgValue'),
					},
				],
				col: 12,
			},
		],
	}
}
